export default __webpack_public_path__ + "static/media/5.d4a9c6e3.jpeg";